export default function initArrowLinks(){
	const buttons = document.querySelectorAll('[class*="btn--arrow"], [id^="gform_submit_button"]');
	
	if(!buttons) return false;

	buttons.forEach(button => {
		let item = button.firstElementChild ? button.firstElementChild : button;
		item.dataset.text = item.textContent;
	})
};